/** sessionStorage key used to persist the pre-login URL across the OIDC redirect flow. */
export const RETURN_TO_KEY = 'hawk:returnTo'
